// フロントエンド用ロガー
// console.log のラッパーとして機能し、Seqにもログを送信

import { getSeqClient } from './seqClient';

// consoleログ出力の有効/無効（環境変数で制御）
const isConsoleEnabled = process.env.NEXT_PUBLIC_ENABLE_CONSOLE_LOG !== 'false';

// 起動時Seq案内メッセージ（1回だけ表示）
let seqBannerShown = false;
const showSeqBanner = () => {
  if (seqBannerShown) return;
  seqBannerShown = true;
  const seqUrl = process.env.NEXT_PUBLIC_SEQ_SERVER_URL;
  if (seqUrl) {
    console.log(
      '%c Seq サーバー動作中 %c\n' +
      'ログ確認: ' + seqUrl + '\n' +
      'consoleログは最小限に設定されています\n' +
      '詳細ログはSeqサーバーで確認してください',
      'background: #5c2d91; color: white; padding: 4px 8px; border-radius: 4px; font-weight: bold;',
      ''
    );
  }
};

// Seqにログを送信（動的に有効/無効を判定）
const sendToSeq = (level, args) => {
  const seqClient = getSeqClient();
  if (!seqClient) return;

  // 動的に有効/無効を判定（localStorageまたは環境変数）
  if (!seqClient.isEnabled()) return;

  const { message, properties } = seqClient.formatArgs(args);
  seqClient.send(level, message, properties);
};

// ロガーオブジェクト
const logger = {
  // 通常ログ
  log: (...args) => {
    showSeqBanner();
    if (isConsoleEnabled) console.log(...args);
    sendToSeq('Information', args);
  },

  // 情報ログ
  info: (...args) => {
    showSeqBanner();
    if (isConsoleEnabled) console.info(...args);
    sendToSeq('Information', args);
  },

  // 警告ログ
  warn: (...args) => {
    showSeqBanner();
    if (isConsoleEnabled) console.warn(...args);
    sendToSeq('Warning', args);
  },

  // エラーログ（エラーは常にconsoleにも出す）
  error: (...args) => {
    showSeqBanner();
    console.error(...args);
    sendToSeq('Error', args);
  },

  // デバッグログ（Seqには送らない）
  debug: (...args) => {
    if (isConsoleEnabled) console.debug(...args);
  },

  // グループ開始（console.groupのラッパー）
  group: (...args) => {
    if (isConsoleEnabled) console.group(...args);
  },

  // グループ終了
  groupEnd: () => {
    if (isConsoleEnabled) console.groupEnd();
  },

  // テーブル表示
  table: (data) => {
    if (isConsoleEnabled) console.table(data);
  },

  // カスタムログ（タグ付き）
  tagged: (tag, level, ...args) => {
    const taggedArgs = [`[${tag}]`, ...args];
    
    switch (level) {
      case 'error':
        logger.error(...taggedArgs);
        break;
      case 'warn':
        logger.warn(...taggedArgs);
        break;
      case 'info':
        logger.info(...taggedArgs);
        break;
      default:
        logger.log(...taggedArgs);
    }
  },
};

// 特定機能向けのタグ付きロガー作成
export const createTaggedLogger = (tag) => {
  return {
    log: (...args) => logger.tagged(tag, 'log', ...args),
    info: (...args) => logger.tagged(tag, 'info', ...args),
    warn: (...args) => logger.tagged(tag, 'warn', ...args),
    error: (...args) => logger.tagged(tag, 'error', ...args),
    debug: (...args) => { if (isConsoleEnabled) console.debug(`[${tag}]`, ...args); },
  };
};

export default logger;
